module.exports = __webpack_public_path__ + "static/drizly_logo-6dd82ea43e35017425a8a0dc92bca18b.png";